import distance from '@turf/distance';
import { isNil } from 'lodash';
import { useMemo } from 'react';

import { Device } from '@/api/devices';

type LatLng = {
    lat: number;
    lng: number;
};
export type GeofenceDisplayData = {
    center: LatLng;
    radius: number;
    isBreached: boolean;
    breachedByMeters: number;
};

export const isSpotterOutOfGeofence = (
    center: LatLng,
    radius: number,
    spotterLocation: LatLng
): { isBreached: boolean; breachedByMeters: number } => {
    const distanceFromGeofenceCenterMeters = distance(
        [center.lng, center.lat],
        [spotterLocation.lng, spotterLocation.lat],
        { units: 'meters' }
    );
    const isBreached = distanceFromGeofenceCenterMeters > radius;
    const breachedByMeters = isBreached ? distanceFromGeofenceCenterMeters - radius : 0;

    return { isBreached, breachedByMeters };
};
export const useGeofenceDisplayData = (device: Device | undefined | null): GeofenceDisplayData | null => {
    return useMemo(() => {
        if (!device) {
            return null;
        }

        const waves = device.waves;
        if (
            !waves?.geofenceEnabled ||
            isNil(waves.geofenceLat) ||
            isNil(waves.geofenceLon) ||
            isNil(waves.geofenceRadius)
        ) {
            return null;
        }

        const currentLocation = device.track?.[0];
        let isBreached = false;
        let breachedByMeters = 0;
        const center = { lat: waves.geofenceLat, lng: waves.geofenceLon };
        const radius = waves.geofenceRadius;

        if (currentLocation) {
            const { isBreached: isGeofenceBreached, breachedByMeters: outOfGeofenceMeters } = isSpotterOutOfGeofence(
                center,
                radius,
                {
                    lat: currentLocation.latitude,
                    lng: currentLocation.longitude,
                }
            );
            isBreached = isGeofenceBreached;
            breachedByMeters = outOfGeofenceMeters;
        }

        return {
            center,
            radius,
            isBreached,
            breachedByMeters,
        };
    }, [device]);
};
